import { useEffect, useState } from 'react';
import { contractsApi } from '../../api/contracts.api';
import { mapSimpleDescriptionOptions } from '../../mappers/contracts.mappers';

export const useAdditionalCostLayers = (model?: string) => {
  const [layerTypes, setLayerTypes] = useState<any[]>([]);
  const [layers, setLayers] = useState<any[]>([]);

  useEffect(() => {
    contractsApi.getCostLayerTypes().then((res) => setLayerTypes(res || []));
  }, []);

  useEffect(() => {
    if (!model) {
      setLayers([]);
      return;
    }

    contractsApi
      .getLayerOptionsByModel(model)
      .then((res) => setLayers(mapSimpleDescriptionOptions(res || [])));
  }, [model]);

  return { layerTypes, layers };
};
